import { injectIntl } from 'react-intl';

import UnitFilter from './UnitFilter';

export default injectIntl(UnitFilter);
